import { combineReducers } from 'redux';
import { ServiceTicketAction, ServiceDeskActionType } from '../../actions/serviceDeskActions';

const loading = (state = false, action: ServiceTicketAction) => {
  switch (action.type) {
    case ServiceDeskActionType.SEND_SERVICE_TICKET:
      return true;
    case ServiceDeskActionType.SEND_SERVICE_TICKET_OK:
    case ServiceDeskActionType.SEND_SERVICE_TICKET_ERROR:
      return false;
    default:
      return state;
  }
};

const error = (state = '', action: ServiceTicketAction) => {
  switch (action.type) {
    case ServiceDeskActionType.SEND_SERVICE_TICKET:
      return '';
    case ServiceDeskActionType.SEND_SERVICE_TICKET_ERROR:
      return action.error;
    default:
      return state;
  }
};

export default combineReducers({ loading, error });
